<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'

import { ActionDropdownButton, EditorIcon, EditorIconType } from '@/components/editor'
import { useEditorStore } from '@/stores'
import { DynamicItemType, DynamicMenuItem } from '@/types'
import { DropdownMenuItem } from '@/ui'

import DynamicConstructsDialog from './DynamicConstructsDialog.vue'

const props = withDefaults(
  defineProps<{
    editor: Editor
    icon?: EditorIconType
    tooltip?: string
    disabled?: boolean
    items?: DynamicMenuItem[]
  }>(),
  {
    icon: undefined,
    tooltip: undefined,
    disabled: false,
    items: () => [],
  }
)

const editorStore = useEditorStore()

const handleSelect = (type: DynamicItemType) => {
  editorStore.dynamicDialogType = type
  editorStore.dynamicDialogCallback = attrs => {
    if (type === 'variable') props.editor.commands.insertVariable(attrs)
    if (type === 'if') props.editor.commands.insertIfBlock(attrs)
    if (type === 'for') props.editor.commands.insertForBlock(attrs)
    if (type === 'tableLoop') props.editor.commands.insertTableLoop(attrs)
  }
}
</script>

<template>
  <ActionDropdownButton :icon="icon" :tooltip="tooltip" :disabled="disabled">
    <DropdownMenuItem
      v-for="(item, idx) in items"
      :key="idx"
      class="flex flex-row items-center gap-2"
      @click="handleSelect(item.type)"
    >
      <EditorIcon :name="item.icon" />
      <span>{{ item.title }}</span>
    </DropdownMenuItem>
  </ActionDropdownButton>

  <DynamicConstructsDialog />
</template>
